/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionvisionary3Inputs */



/**
* | output |
* | --- |
* | "You’re a catalyst for change. You love inspiring others, spotting hidden potential, and changing how people see themselves and their lives just through conve..." |
*
* @param {Personalityarchetypedescriptionvisionary3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionvisionary3 = /** @type {((inputs?: Personalityarchetypedescriptionvisionary3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionvisionary3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re a catalyst for change. You love inspiring others, spotting hidden potential, and changing how people see themselves and their lives just through conversation.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eres un catalizador para el cambio. Te encanta inspirar a otros, descubrir el potencial oculto y cambiar la forma en que las personas se ven a sí mismas.")
	return /** @type {LocalizedString} */ ("Ты — катализатор перемен. Тебе нравится вдохновлять других, видеть скрытый потенциал и разговорами менять то, как люди смотрят на себя и на свою жизнь.")
});
export { personalityarchetypedescriptionvisionary3 as "personalityArchetypeDescriptionVisionary" }